import { Component, ChangeDetectorRef } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { ReactiveFormsModule, FormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateService, TranslatePipe, TranslateDirective, LangChangeEvent } from "@ngx-translate/core";
import { AcademicTaxesService } from '../../../../services/academicTaxes.service';
import { AcademicFeeDto } from '../../../../models/academicfeedto';
import { Subscription } from 'rxjs';
import { RateModelDto } from '../../../../models/ratemodeldto';
import { TaxesService } from '../../../../services/taxes.service';
import { AcademicFeePriceDto } from '../../../../models/academicfeepricedto';
import { AcademicTaxesPriceService } from '../../../../services/academicTaxesPrices.service';
import { VatPatternDto } from '../../../../models/vatPattern/vatpatterndto';
import { VatPatternService } from '../../../../services/vatpattern.service';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { ErrorModalComponent } from '../../../../components/error-modal/error-modal.component';
import { AcademicFeeRequest } from '../../../../models/academicFeeRequest';
import { AcademicFeeResponse } from '../../../../models/academicFeeResponse';
import { RateModelRequest } from '../../../../models/rateModelRequest';
import { RateModelResponse } from '../../../../models/rateModelResponse';
import { AcademicFeePriceRequest } from '../../../../models/academicFeePriceRequest';
import { AcademicFeePriceResponse } from '../../../../models/academicFeePriceResponse';
import { VatPatternRequest } from '../../../../models/vatPattern/vatPatternRequest';
import { VatPatternResponse } from '../../../../models/vatPattern/vatPatternResponse';
import { SharedService } from '../../../../services/shared.service';
import { AlertComponentComponent } from '../../../../components/alert/alert-component.component';
import { DiscountService } from '../../../../services/discountService.service';
import { GeneralDiscountCatalogRequest, GeneralDiscountCatalogResponse, IdOwnRateDiscountDto, IdOwnRateDiscountDtoRequest, IdOwnRateDiscountDtoResponse } from '../../../../models/discountGeneralCatalog/OwnRateDiscount.modelDto';
import { GeneralDiscountCatalogDto } from '../../../../models/discountGeneralCatalog/GeneralDiscountCatalogDto.model';
import { DiscountRateModelCatalogRequest, DiscountRateModelCatalogResponse } from '../../../../models/discountGeneralCatalog/DiscountRateModelCatalog.model';

@Component({
  selector: 'app-academictaxes',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, ReactiveFormsModule, FormsModule, CommonModule, TranslatePipe, TranslateDirective, PaginatorComponent, ErrorModalComponent, AlertComponentComponent],
  templateUrl: './academictaxes.component.html',
  styleUrl: './academictaxes.component.css'
})
export class AcademictaxesComponent {

  links: any[] = [];
  subLinks: any[] = [];
  isCreate: boolean = false; // Cambia a modo de creación
  isCreateFeePrice: boolean = false; // Cambia a modo de creación
  isCreateOwnRateDiscount: boolean = false; // Cambia a modo de creación
  isCreatedFeePrice: boolean = false; // Cambia a modo de creación
  isCreatedOwnRateDiscount: boolean = false; // Cambia a modo de creación
  isCreated: boolean = false; // se ha creado
  isError: boolean = false; // se ha producido un error
  isErrorFeePrice: boolean = false; // se ha producido un error
  isErrorOwnRateDiscount: boolean = false; // se ha producido un error
  isClone: boolean = false; // se ha producido un error

  currentLanguage: string = 'es'; // Idioma actual

  selectedAcademicFee: AcademicFeeDto = new AcademicFeeDto(); // Tasa académica seleccionada
  selectedOwnRateDiscount: IdOwnRateDiscountDto = new IdOwnRateDiscountDto(); // Tasa académica seleccionada

  discountRateModelRequest: DiscountRateModelCatalogRequest = new DiscountRateModelCatalogRequest();
  discountRateModelResponse: DiscountRateModelCatalogResponse = new DiscountRateModelCatalogResponse();

  modifTranslates: boolean = false; // Variable para determinar si se han modificado las traducciones
  selectedRowId: any = null;
  selectedAcademicPriceId: any = null; // Precio académico seleccionado
  selectedOwnRateDiscountId: any = null; // Precio académico seleccionado
  selectedRateModel: RateModelDto = new RateModelDto(); // Modelo de tasa seleccionado

  listVatPattern: VatPatternDto[] = []; // Lista de patrones de IVA
  createPrice = true; // Variable para determinar si se crea un nuevo precio académico
  private langChangeSubscription!: Subscription;
  showErrorModal: boolean = false; // Controla la visibilidad del modal de error
  errorTitle: string = ''; // Título del modal de error
  errorMessage: string = ''; // Mensaje del modal de error
  message: Array<any> = []; // Mensaje del modal de error

  academicFeeRequest: AcademicFeeRequest = new AcademicFeeRequest(); // Objeto para la solicitud de tasa académica
  academicFeeResponse: AcademicFeeResponse = new AcademicFeeResponse(); // Objeto para la respuesta de tasa académica

  modelRequest: RateModelRequest = new RateModelRequest();
  modelResponse: RateModelResponse = new RateModelResponse();

  ownRateDiscountRequest: IdOwnRateDiscountDtoRequest = new IdOwnRateDiscountDtoRequest();
  ownRateDiscountResponse: IdOwnRateDiscountDtoResponse = new IdOwnRateDiscountDtoResponse();

  academicFeePriceRequest: AcademicFeePriceRequest = new AcademicFeePriceRequest(); // Objeto para la solicitud de precio académico
  academicFeePriceResponse: AcademicFeePriceResponse = new AcademicFeePriceResponse(); // Objeto para la respuesta de precio académico

  vatPatternRequest: VatPatternRequest = new VatPatternRequest(); // Objeto para la solicitud de patrón de IVA
  vatpatternResponse: VatPatternResponse = new VatPatternResponse(); // Objeto para la respuesta de patrón de IVA

  discountReponse: GeneralDiscountCatalogResponse = new GeneralDiscountCatalogResponse();
  discountRequest: GeneralDiscountCatalogRequest = new GeneralDiscountCatalogRequest();

  constructor(private routelinks: RoutelinksService, private cdr: ChangeDetectorRef, private academictaxesservice: AcademicTaxesService,
    private translateService: TranslateService, private taxesService: TaxesService, private academicTaxesPriceService: AcademicTaxesPriceService,
    private vatPatternService: VatPatternService, private sharedService: SharedService, private discountServices: DiscountService) {
    this.currentLanguage = this.translateService.currentLang || 'es'; // Establece el idioma actual
  }

  filterParams = new FormGroup({
    taxModel: new FormControl(), // Control para el select "Tipo de tasa"
  });

  // Formulario reactivo para los precios académicos
  formAcademicPrices = new FormGroup({
    startDate: new FormControl('', Validators.required), // Campo de fecha obligatorio
    endDate: new FormControl(''), // Campo de fecha opcional
    firstTermPayment: new FormControl(false), // Select obligatorio
    price: new FormControl('', [Validators.required, Validators.min(0)]), // Campo numérico obligatorio
    idVatPattern: new FormControl(), // Select opcional
  });

  // Formulario reactivo para el modal de descuento
  formDiscount = new FormGroup({
    discountCode: new FormControl(),
    importType: new FormControl('I'),
    idOwnRateDiscount: new FormControl(),
    rateType: new FormControl('A', Validators.required),
    discountPercentage: new FormControl(),
    fixedDiscountAmount: new FormControl(),
    discountOrderNumber: new FormControl(0, Validators.required),
    startDate: new FormControl('', Validators.required),
    endDate: new FormControl(''),
    idRateModel: new FormControl(),
    idGeneralDiscountCatalog: new FormControl(),
  });

  academicservicesForm = new FormGroup({
    feeType: new FormControl(''), // Select Tipo de tasa
    active: new FormControl(''), // Select Activo
    numberOfRegistration: new FormControl('', Validators.required), // Select Número de matrícula
    descripcionCat: new FormControl('', Validators.required), // Input descripción en catalán
    descripcionCast: new FormControl('', Validators.required), // Input descripción en castellano
    descripcionIng: new FormControl('', Validators.required), // Input descripción en inglés
  });

  ngOnInit(): void {
    this.links = this.routelinks.linksTaxes; // Inicializa la propiedad en ngOnInit
    this.subLinks = this.routelinks.subLinksTaxes; // Inicializa la propiedad en el constructor

    this.loadRateModels(true);
    this.loadVatPatterns(true);
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang; // Actualizar el idioma actual
      this.cdr.detectChanges();
      this.loadRateModels(true);
      this.loadVatPatterns(true);
    });

    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.academicFeeResponse.pageDto.currentPage = page;
      this.getAcademicFees(true);
    });


    this.filterParams.get('taxModel')?.valueChanges.subscribe((value) => {
      this.selectedRateModel = this.modelResponse.listRateModelDto.find((item) => item.idRateModel === Number(value)) || new RateModelDto(); // Asegura que el valor sea numérico y crea una nueva instancia correctamente
      this.getAcademicFees(true); // Llama a la función para obtener las tasas académicas
      this.selectedRowId = null;
      this.isCreate = false
    });

    this.formDiscount.get('importType')?.valueChanges.subscribe((value) => {
      value == 'I' ? this.formDiscount.get('discountPercentage')?.patchValue(0) : null
      value == 'P' ? this.formDiscount.get('fixedDiscountAmount')?.patchValue(0) : null
    });
  }

  changeDescompte() {
    if (this.selectedOwnRateDiscountId == null) {
      this.formDiscount.get('fixedDiscountAmount')?.patchValue(0)
      this.formDiscount.get('discountPercentage')?.patchValue(0)
      let discount: GeneralDiscountCatalogDto[] = this.discountReponse.GeneralDiscountCatalogDto.filter(disc => { return disc.idGeneralDiscountCatalog == this.formDiscount.get('idGeneralDiscountCatalog')?.value })
      if (discount[0].discountFixedAmount && discount[0].discountFixedAmount > 0) {
        this.formDiscount.get('fixedDiscountAmount')?.patchValue(discount[0].discountFixedAmount)
        this.formDiscount.get('importType')?.patchValue("I")
      }
      if (discount[0].discountPercentage && discount[0].discountPercentage > 0) {
        this.formDiscount.get('discountPercentage')?.patchValue(discount[0].discountPercentage)
        this.formDiscount.get('importType')?.patchValue("P")
      }
    }
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  get hasAcademicFees(): boolean {
    return this.academicFeeResponse.listAcademicFeeDto && this.academicFeeResponse.listAcademicFeeDto.length > 0;
  }

  getAcademicFees(init: boolean): void {
    if (!init) {
      this.academicFeeRequest.pageRequest.page = this.academicFeeResponse.pageDto.currentPage;
    }
    this.academictaxesservice.getListAcademicTaxes(this.academicFeeRequest.pageRequest, this.selectedRateModel.codeRateModel).subscribe({
      next: response => {
        if (response != null) {
          this.academicFeeResponse.listAcademicFeeDto = response.listOwnAcademicFee.map((rt: any) => {
            return {
              ...rt,
              ownAcademicFeeTraductionDto: rt.ownAcademicFeeTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
            };
          });
          if (response.pageDto !== undefined) {
            this.academicFeeResponse.pageDto = response.pageDto;
          }
          console.log(this.academicFeeResponse.listAcademicFeeDto)
        }
      },
      error: (err) => {
        console.error('Error al obtener las tasas académicas:', err);
      }
    });
  }

  // Seleccionar o deseleccionar una fila en una tabla específica
  toggleRow(row: any): void {
    if (this.selectedRowId === row.idOwnAcademicFee) {
      window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
      setTimeout(() => {
        this.selectedRowId = null; // Deselecciona si ya estaba seleccionada
        this.selectedAcademicPriceId = null
        this.selectedOwnRateDiscountId = null

      }, 350);
    } else {
      this.isCreate = false; // Cambia a modo de edición
      this.selectedRowId = row.idOwnAcademicFee; // Selecciona la nueva fila
      this.selectedAcademicPriceId = null;
      this.isCreateFeePrice = false;
      this.loadAcademicTaxesById();
      this.loadAcademicFeePricesByAcademicFeeId(true); // Carga los precios académicos por ID de tasa académica 
      this.loadOwnRateDiscountByRateType(row.idOwnAcademicFee)
      this.loadDiscounts()
      this.loadDiscountsRateModel()
      this.cdr.detectChanges();
      window.scrollTo(0, 600);
      this.academicservicesForm.get('feeType')?.disable()
      this.academicservicesForm.get('numberOfRegistration')?.disable()
      //Rellenar formComponent con el obj de la fila seleccionada
    }
  }

  loadOwnRateDiscountByRateType(id: number) {
    this.discountServices.loadOwnRateDiscountByRateType(this.ownRateDiscountRequest.pageRequest, id, "A").subscribe(list => {
      this.ownRateDiscountResponse.IdOwnRateDiscountDto = list.listOwnRateDiscount
    })
  }

  toggleRowFeePrice(row: any): void {
    if (this.selectedAcademicPriceId === row.idOwnAcademicFeePrice) {
      setTimeout(() => {
        this.selectedAcademicPriceId = null; // Deselecciona si ya estaba seleccionada

      }, 350);
    } else {
      if (row) {
        this.formAcademicPrices.patchValue({
          startDate: row.startDate,
          endDate: row.endDate,
          firstTermPayment: row.firstTermPayment,
          price: row.price,
          idVatPattern: row.vatPatternDto.idVatPattern,
        });
        this.selectedAcademicPriceId = row.idOwnAcademicFeePrice; // Asigna el ID del precio académico seleccionado
      }
      this.cdr.detectChanges();
      //Rellenar formComponent con el obj de la fila seleccionada
    }
  }

  toggleRowAcademicDiscount(row: any): void {
    if (this.selectedOwnRateDiscountId === row.idOwnRateDiscount) {
      setTimeout(() => {
        this.selectedOwnRateDiscountId = null; // Deselecciona si ya estaba seleccionada
      }, 350);
    } else {
      if (row) {
        console.log(row)
        this.formDiscount.patchValue({
          startDate: row.startDate,
          endDate: row.endDate,
          rateType: row.rateType,
          idOwnRateDiscount: row.idOwnRateDiscount,
          discountOrderNumber: row.discountOrderNumber,
          fixedDiscountAmount: row.fixedDiscountAmount,
          discountPercentage: row.discountPercentage,
          idRateModel: row.rateModelDto.codeRateModel,
          idGeneralDiscountCatalog: row.generalDiscountCatalogDto.idGeneralDiscountCatalog
        });
        //this.formDiscount.disable()
        this.selectedOwnRateDiscount = row
        this.isCreatedOwnRateDiscount = false
        this.selectedOwnRateDiscountId = row.idOwnRateDiscount; // Asigna el ID del precio académico seleccionado
        row.discountPercentage > 0 ? this.formDiscount.get('importType')?.patchValue('P') : this.formDiscount.get('importType')?.patchValue('I')
        this.formDiscount.get('idGeneralDiscountCatalog')?.disable()

      }
      this.cdr.detectChanges();
      //Rellenar formComponent con el obj de la fila seleccionada
    }
  }

  newRegister() {
    this.formAcademicPrices.reset()
    this.isCreateFeePrice = true;
    this.selectedAcademicPriceId = null;
  }

  newAcademicDiscount() {
    this.formDiscount.reset()
    this.formDiscount.enable()
    this.selectedOwnRateDiscountId = null;
    this.isCreatedOwnRateDiscount = true;
    this.formDiscount.get('idRateModel')?.disable()
    this.formDiscount.get('idRateModel')?.patchValue(this.selectedRateModel.codeRateModel)
  }

  newModel(): void {
    this.academicservicesForm.reset(); // Limpia los datos del formulario
    this.academicservicesForm.enable()
    this.selectedRowId = null; // Deselecciona la fila
    this.isCreate = true; // Cambia a modo de creación
    this.selectedAcademicPriceId = this.selectedAcademicPriceId = this.selectedOwnRateDiscountId = null;
    this.cdr.detectChanges();
    window.scrollTo(0, 600);
  }

  // Guardar los datos del formulario
  saveRecord(): void {
    if (this.formAcademicPrices.valid) {
      let academicFeePriceDto = new AcademicFeePriceDto(); // Inicializa el objeto AcademicFeePriceDto
      this.createPrice = true; // Variable para determinar si se crea un nuevo precio académico
      if (this.selectedAcademicPriceId) {
        academicFeePriceDto.idOwnAcademicFeePrice = this.selectedAcademicPriceId; // Asigna el ID del precio académico seleccionado
        this.createPrice = false; // No crea un nuevo precio académico si ya existe uno
      }
      academicFeePriceDto.startDate = this.formAcademicPrices.get('startDate')?.value || undefined; // Asigna la fecha de inicio
      academicFeePriceDto.endDate = this.formAcademicPrices.get('endDate')?.value || undefined; // Asigna la fecha de fin
      academicFeePriceDto.firstTermPayment = this.formAcademicPrices.get('firstTermPayment')?.value || false; // Asigna el primer pago
      academicFeePriceDto.price = Number(this.formAcademicPrices.get('price')?.value || undefined); // Asigna el precio
      if (!academicFeePriceDto.vatPatternDto) {
        academicFeePriceDto.vatPatternDto = new VatPatternDto(); // Inicializa el objeto VatPatternDto si es undefined o vacío
      }
      academicFeePriceDto.vatPatternDto.idVatPattern = this.formAcademicPrices.get('idVatPattern')?.value || undefined; // Asigna el ID del patrón de IVA

      if (!academicFeePriceDto.ownAcademicFeeDto) {
        academicFeePriceDto.ownAcademicFeeDto = new AcademicFeeDto(); // Inicializa el objeto AcademicFeeDto si es undefined o vacío
      }
      academicFeePriceDto.ownAcademicFeeDto.idOwnAcademicFee = this.selectedRowId; // Asigna el ID de la tasa académica seleccionada

      if (this.createPrice || this.isClone) {
        academicFeePriceDto.idOwnAcademicFeePrice = undefined;
        this.academicTaxesPriceService.insertPrice(academicFeePriceDto, this.currentLanguage).subscribe({
          next: (response) => {
            this.errorMessage = "S'ha creat correctament";
            this.selectedAcademicPriceId = null; // Deselecciona si ya estaba seleccionada
            this.isCreatedFeePrice = true;
            this.isErrorFeePrice = false
            this.isCreateFeePrice = false
            this.loadAcademicFeePricesByAcademicFeeId(false); // Actualiza la lista después de guardar
            this.isClone = false
          }, error: (err) => {
            this.isErrorFeePrice = true
            this.isCreatedFeePrice = false;
            console.error('Error al crear el precio académico:', err);
            // Llama al modal de error para mostrar el mensaje recibido
            this.errorMessage = err.error.message; // Mensaje de error
          }
        });
      } else {
        this.academicTaxesPriceService.updatePrice(academicFeePriceDto, this.currentLanguage).subscribe({
          next: (response) => {
            this.errorMessage = "S'ha editat correctament"
            this.isCreatedFeePrice = true;
            this.isCreateFeePrice = false
            this.isErrorFeePrice = false
            this.loadAcademicFeePricesByAcademicFeeId(false); // Actualiza la lista después de guardar
            this.isClone = false

          }, error: (err) => {
            console.error('Error al actualizar el precio académico:', err);
            // Llama al modal de error para mostrar el mensaje recibido
            this.isErrorFeePrice = true;
            this.isCreatedFeePrice = false;
            this.errorMessage = err.error.message; // Mensaje de error
          }
        });
      }

    } else {
      this.isErrorFeePrice = true;
      this.isCreatedFeePrice = false;
      this.errorMessage = "obligatorios"
    }
  }
  //#region Servicios Academicos
  // Método para guardar los datos del formulario
  saveAcademicServices(): void {
    if (this.academicservicesForm.valid) {
      this.bindFormToObj();
      if (this.checkForNullTranslations()) {
        return; // Detiene la ejecución si hay traducciones nulas
      }

      // Si iscreate es falso, significa que se está editando un registro existente
      if (!this.isCreate) {
        this.academictaxesservice.updateAcademicFee(this.modifTranslates, this.selectedAcademicFee).subscribe({
          next: (response) => {
            this.isCreated = true;
            this.isError = false;
            this.errorMessage = "S'ha editat correctament"
            this.getAcademicFees(true); // Actualiza la lista después de guardar
          }
          , error: (err) => {
            this.isError = true;
            this.isCreated = false
            this.errorMessage = err.error.message
            console.error('Error al actualizar la tasa académica:', err);
          }
        });

      } else {
        this.academictaxesservice.insertAcademicFee(this.selectedAcademicFee).subscribe({
          next: (response) => {
            this.isCreated = true;
            this.isError = false;
            this.errorMessage = "S'ha creat correctament"
            this.selectedRowId = null; // Deselecciona si ya estaba seleccionada
            this.academicservicesForm.reset(); // Limpia los datos del formulario
            this.getAcademicFees(true); // Actualiza la lista después de guardar
          }
          , error: (err) => {
            this.isError = true
            this.isCreated = false
            this.errorMessage = err.error.message
            console.error('Error al crear la tasa académica:', err);
          }
        });
      }
    } else {
      this.isError = true
      this.errorMessage = 'obligatorios'
    }
  }

  saveOwnRateDiscount() {
    if (this.controlDates(this.formDiscount.get('startDate')?.value, this.formDiscount.get('endDate')?.value)) {
      this.isErrorOwnRateDiscount = false
      this.isCreateOwnRateDiscount = false;
      this.isErrorOwnRateDiscount = true
      this.isCreateOwnRateDiscount = false;
      this.errorMessage = 'fechas';
      return
    }
    if (this.selectedOwnRateDiscountId) {
      this.message = this.ownRateDiscountResponse.IdOwnRateDiscountDto.filter(resp => { return resp.idOwnRateDiscount != this.selectedOwnRateDiscountId && resp.discountOrderNumber == this.formDiscount.get('discountOrderNumber')?.value })
    }
    else {
      this.message = this.ownRateDiscountResponse.IdOwnRateDiscountDto.filter(resp => { return resp.discountOrderNumber == this.formDiscount.get('discountOrderNumber')?.value })
    }
    if(this.message.length > 0){
      return
    }
    this.formDiscount.get('rateType')?.patchValue('A')
    if (this.formDiscount.valid) {

      this.buildOwnRateDiscount()
      if (this.selectedOwnRateDiscountId) {
        this.discountServices.updateOwnRateDiscount(this.selectedOwnRateDiscount).subscribe({
          next: (response) => {
            this.isCreateOwnRateDiscount = true;
            this.isErrorOwnRateDiscount = false;
            this.errorMessage = "S'ha editat correctament"
            this.loadOwnRateDiscountByRateType(this.selectedRowId); // Actualiza la lista después de guardar
          }
          , error: (err) => {
            this.isErrorOwnRateDiscount = true
            this.isCreateOwnRateDiscount = false;
            this.errorMessage = err.error.message
            this.loadOwnRateDiscountByRateType(this.selectedRowId); // Actualiza la lista después de guardar
            console.error('Error al actualizar la tasa académica:', err);
          }
        });
      } else {
        this.discountServices.insertOwnRateDiscount(this.selectedOwnRateDiscount).subscribe({
          next: (response) => {
            this.isCreateOwnRateDiscount = true;
            this.errorMessage = "S'ha creat correctament"
            this.selectedOwnRateDiscountId = null; // Deselecciona si ya estaba seleccionada
            this.isCreatedOwnRateDiscount = false
            this.isErrorOwnRateDiscount = false;

            this.formDiscount.reset(); // Limpia los datos del formulario
            this.loadOwnRateDiscountByRateType(this.selectedRowId); // Actualiza la lista después de guardar
          }
          , error: (err) => {
            this.isErrorOwnRateDiscount = true
            this.isCreateOwnRateDiscount = false;
            this.errorMessage = err.error.message
            console.error('Error al crear la tasa académica:', err);
          }
        });
      }
    } else {
      this.isErrorOwnRateDiscount = true
      this.isCreateOwnRateDiscount = false;
      this.errorMessage = 'obligatorios'
    }
  }

  controlDates(startDate: any, dateEnd: any): boolean {
    if (!dateEnd) { return false }
    return (new Date(startDate) > new Date(dateEnd)) ? true : false;
  }

  buildOwnRateDiscount() {
    this.selectedOwnRateDiscount.generalDiscountCatalogDto = new GeneralDiscountCatalogDto()
    this.selectedOwnRateDiscount.rateModelDto = new RateModelDto()

    this.selectedOwnRateDiscount.discountOrderNumber = this.formDiscount.get('discountOrderNumber')?.value || undefined
    this.selectedOwnRateDiscount.discountPercentage = this.formDiscount.get('discountPercentage')?.value
    this.selectedOwnRateDiscount.endDate = this.formDiscount.get('endDate')?.value || undefined
    this.selectedOwnRateDiscount.startDate = this.formDiscount.get('startDate')?.value || undefined
    this.selectedOwnRateDiscount.fixedDiscountAmount = this.formDiscount.get('fixedDiscountAmount')?.value
    this.selectedOwnRateDiscount.rateType = "A"
    this.selectedOwnRateDiscount.rateId = this.selectedRowId
    this.selectedOwnRateDiscount.generalDiscountCatalogDto ? this.selectedOwnRateDiscount.generalDiscountCatalogDto.idGeneralDiscountCatalog = this.formDiscount.get('idGeneralDiscountCatalog')?.value || undefined : null
    this.selectedOwnRateDiscount.generalDiscountCatalogDto ? this.selectedOwnRateDiscount.generalDiscountCatalogDto.discountCode = this.discountReponse.GeneralDiscountCatalogDto.filter(disc => { return disc.idGeneralDiscountCatalog == this.formDiscount.get('idGeneralDiscountCatalog')?.value })[0]?.discountCode : null
    this.selectedOwnRateDiscount.rateModelDto ? this.selectedOwnRateDiscount.rateModelDto.idRateModel = this.selectedRateModel.idRateModel : null
    this.selectedOwnRateDiscount.rateModelDto ? this.selectedOwnRateDiscount.rateModelDto.codeRateModel = this.selectedRateModel.codeRateModel : null

    !this.selectedOwnRateDiscountId ? this.selectedOwnRateDiscount.idOwnRateDiscount = undefined : null
  }

  // Método para cancelar y reiniciar el formulario
  onCancel(): void {
    this.academicservicesForm.reset(); // Limpia los datos del formulario
    this.selectedRowId = this.selectedAcademicPriceId = this.selectedOwnRateDiscountId = null; // Deselecciona cualquier fila
    this.isCreate = this.isCreateFeePrice = this.isCreatedOwnRateDiscount = false; // Cambia a modo cerrado
    this.cdr.detectChanges(); // Detecta cambios para actualizar la vista
    window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
  }

  // Método auxiliar para verificar traducciones nulas
  private checkForNullTranslations(): boolean {
    const hasNullTranslations = this.selectedAcademicFee.ownAcademicFeeTraductionDto?.some(translation =>
      !translation.description
    );

    if (hasNullTranslations) {
      console.log('Mostrando modal de error por traducciones nulas');
      this.isErrorFeePrice = true
      this.errorMessage = this.translateService.instant('error.message.translations');
      return true; // Indica que hay traducciones nulas
    }

    return false; // No hay traducciones nulas
  }

  bindFormToObj(): void {
    // Asigna los valores del formulario a la tasa académica seleccionada
    if (!this.isCreate) {
      this.selectedAcademicFee.idOwnAcademicFee = this.selectedRowId; // Asigna el ID de la tasa académica seleccionada
    } else {
      this.selectedAcademicFee = new AcademicFeeDto(); // Inicializa de 0 el objeto
    }

    this.selectedAcademicFee.numberOfRegistration = this.academicservicesForm.get('numberOfRegistration')?.value || undefined; // Asigna el número de matrícula 
    this.selectedAcademicFee.active = this.selectedRateModel.active // Asigna el estado activo
    this.selectedAcademicFee.rateType = this.academicservicesForm.get('rateType')?.value || 'N'
    if (!this.selectedAcademicFee.rateModelDto) {
      this.selectedAcademicFee.rateModelDto = {}; // Inicializa rateModelTraductionDto si es undefined
    }

    if (!this.selectedAcademicFee.ownAcademicFeeTraductionDto || this.selectedAcademicFee.ownAcademicFeeTraductionDto.length === 0) {
      this.selectedAcademicFee.ownAcademicFeeTraductionDto = [
        { languageDto: { idLanguage: 1 }, description: undefined },
        { languageDto: { idLanguage: 2 }, description: undefined },
        { languageDto: { idLanguage: 3 }, description: undefined }
      ]; // Inicializa ownAcademicFeeTraductionDto si es undefined o vacío
    }

    this.selectedAcademicFee.ownAcademicFeeTraductionDto.forEach((translation) => {
      if (translation.languageDto?.code === "es" || translation.languageDto?.idLanguage === 1) {
        if (translation.description != this.academicservicesForm.get('descripcionCast')?.value) {
          this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
        }
        translation.description = this.academicservicesForm.get('descripcionCast')?.value ?? undefined;
      } else if (translation.languageDto?.code === "ca" || translation.languageDto?.idLanguage === 2) {
        if (translation.description != this.academicservicesForm.get('descripcionCat')?.value) {
          this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
        }
        translation.description = this.academicservicesForm.get('descripcionCat')?.value ?? undefined;
      } else if (translation.languageDto?.code === "en" || translation.languageDto?.idLanguage === 3) {
        if (translation.description != this.academicservicesForm.get('descripcionIng')?.value) {
          this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
        }
        translation.description = this.academicservicesForm.get('descripcionIng')?.value ?? undefined;
      }
    });
    this.selectedAcademicFee.rateModelDto.idRateModel = this.selectedRateModel.idRateModel; // Asigna el ID del modelo de tasa
  }

  //#region Datos
  loadAcademicTaxesById(): void {
    // Aquí puedes implementar la lógica para cargar los servicios académicos
    this.academictaxesservice.getAcademicFeeById(this.selectedRowId).subscribe({
      next: (response) => {

        this.selectedAcademicFee = response; // Asigna la tasa académica seleccionada

        // Verifica si rateModelTraductionDto está definido y tiene suficientes elementos
        const catalanIndex = this.selectedAcademicFee?.ownAcademicFeeTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "ca"
        ) ?? -1;

        const spanishIndex = this.selectedAcademicFee?.ownAcademicFeeTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "es"
        ) ?? -1;

        const englishIndex = this.selectedAcademicFee?.ownAcademicFeeTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "en"
        ) ?? -1;
        this.academicservicesForm.patchValue({
          feeType: response.rateType,
          numberOfRegistration: response.numberOfRegistration,
          descripcionCast: spanishIndex >= 0 ? this.selectedAcademicFee?.ownAcademicFeeTraductionDto?.[spanishIndex]?.description || '' : '',
          descripcionCat: catalanIndex >= 0 ? this.selectedAcademicFee?.ownAcademicFeeTraductionDto?.[catalanIndex]?.description || '' : '',
          descripcionIng: englishIndex >= 0 ? this.selectedAcademicFee?.ownAcademicFeeTraductionDto?.[englishIndex]?.description || '' : '',
        });
      }, error: (err) => {
        console.error('Error al cargar los datos:', err);
      }
    });
  }

  loadAcademicFeePricesByAcademicFeeId(init: boolean): void {
    if (!init) {
      this.academicFeePriceRequest.pageRequest.page = this.academicFeePriceResponse.pageDto.currentPage;
    }
    // Aquí puedes implementar la lógica para cargar los precios académicos por ID de tasa académica
    this.academicTaxesPriceService.getByAcademicFeeId(this.academicFeePriceRequest.pageRequest, this.selectedRowId).subscribe({
      next: response => {
        if (response != null) {
          this.academicFeePriceResponse.listAcademicFeePriceDto = response.listOwnAcademicFeePrice;
          if (response.pageDto !== undefined) {
            this.academicFeePriceResponse.pageDto = response.pageDto;
          }
        }
      }
    });
  }

  loadRateModels(init: boolean): void {
    if (!init) {
      this.modelRequest.pageRequest.page = this.modelResponse.pageDto.currentPage;
    }
    this.modelRequest.pageRequest.sizePage = 1000; // Carga un número grande de modelos de tasa para evitar la paginación en el select
    this.taxesService.getListTaxesAll(this.modelRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          // Asigna la lista de modelos a la propiedad listModels para mostrarlos en la tabla
          this.modelResponse.listRateModelDto = response.listRateModel.map((rt: any) => {
            return {
              ...rt,
              rateModelTraductionDto: rt.rateModelTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
            };
          });
          this.modelResponse.listRateModelDto = this.modelResponse.listRateModelDto.filter(list => { return list.academicFees == true })
          if (response.pageDto !== undefined) {
            this.modelResponse.pageDto = response.pageDto;
          }
        }
      }, error: error => {
        this.modelResponse.listRateModelDto = []; // Asigna una lista vacía en caso de error
      }
    });
  }

  loadVatPatterns(init: boolean): void {
    if (!init) {
      this.vatPatternRequest.pageRequest.page = this.vatpatternResponse.pageDto.currentPage;
    }

    this.vatPatternService.getListVatPattern(this.vatPatternRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.listVatPattern = response.listVatPattern.map((rt: any) => {
            return {
              ...rt,
              vatPatternTraductionDto: rt.vatPatternTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
            };
          });
          if (response.pageDto !== undefined) {
            this.vatpatternResponse.pageDto = response.pageDto;
          }
        }
      },
      error: (err) => {
        console.error('Error al obtener los patrones de IVA:', err);
      }
    });
  }

  loadDiscounts() {
    this.discountServices.getListGeneralDiscountCatalog(this.discountRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.discountReponse.GeneralDiscountCatalogDto = response.listGeneralDiscountCatalog.map((rt: any) => {
            return {
              ...rt,
              generalDiscountCatalogTraductionDto: rt.generalDiscountCatalogTraductionDto.filter((t: any) => t.languageDto.code.includes(this.translateService.currentLang || 'es')),
            };
          });
          response.pageDto !== undefined ? this.discountReponse.pageDto = response.pageDto : null
        }
        console.log(this.discountReponse.GeneralDiscountCatalogDto)
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  loadDiscountsRateModel() {
    console.log(this.selectedRowId)
    this.discountServices.getListDiscountRateModelCatalog(this.discountRequest.pageRequest, this.selectedRateModel.idRateModel).subscribe({
      next: response => {
        if (response != null) {
          this.discountRateModelResponse.discountRateModelCatalogDto = response.listDiscountRateModelCatalog.filter((discount: { rateModelDto: { idRateModel: number | null; }; }) => { return discount.rateModelDto.idRateModel == this.filterParams.get('taxModel')?.value })
          this.discountRateModelResponse.discountRateModelCatalogDto = sortByDiscountCode(this.discountRateModelResponse.discountRateModelCatalogDto)

        }
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  getDiscountDescription(id?: any): string {
    let descr;
    let discount = this.discountReponse.GeneralDiscountCatalogDto.filter(list => { return list.idGeneralDiscountCatalog == id })
    if (discount.length === 0) {
      return '';
    }
    discount[0].generalDiscountCatalogTraductionDto ? descr = discount[0].generalDiscountCatalogTraductionDto[0].discountDescription : null;
    return descr || ''
  }

  clone() {
    this.isClone = true;
    this.isCreatedFeePrice = true;
    this.selectedAcademicPriceId = null
    this.errorMessage = "S'ha clonat correctament"
  }

  controlNumberOfRegistration(numberOfRegistration: string): boolean {
    let exists = this.academicFeeResponse.listAcademicFeeDto.filter(list => { return list.numberOfRegistration == numberOfRegistration })
    return exists.length > 0 ? false : true;
  }

  isDiscountValid(discountCode: any): boolean {
    console.log(this.ownRateDiscountResponse.IdOwnRateDiscountDto)
    const discount = this.ownRateDiscountResponse.IdOwnRateDiscountDto.find(disc => disc.generalDiscountCatalogDto?.discountCode === discountCode);
    console.log(discount)
    return discount == undefined;
  }

  //#endregion
}
function sortByDiscountCode(array: any[]) {
  return array.sort((a: { generalDiscountCatalogDto: { discountCode: string; }; }, b: { generalDiscountCatalogDto: { discountCode: any; }; }) =>
    a.generalDiscountCatalogDto.discountCode.localeCompare(b.generalDiscountCatalogDto.discountCode)
  );
}